import React, {useEffect} from "react";
import {connect, useSelector} from "react-redux";
import {Card, CardBody, CardTitle} from "reactstrap";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";

// components
import AfiForm from "./_form";
import AfiFilters from "./_filters";
import {ConfirmDelete} from "../../../components/confirmAlert/ConfirmDelete";
import TranslateButton from "../../../components/buttons/TranslateButton";
import {GenericTableButton} from "../../../components/buttons/buttonsActions";
import {ModalFormContainer} from "../../../components/confirmAlert/ModalFormContainer";
import {ActiveFormatter} from "../../../components/tables/activeFormater";

// labels
import {TT_DELETE, TT_EDIT} from "../../../components/i18n/toolTips";
import {LB_ACTIONS, LB_ACTIVE, LB_CODE, LB_NAME, LIST, NO_DATA_FOUND} from "../../../components/i18n/i18n";

// actions
import { setFilter, setTableParams, setForm, setItem } from "../../../redux/actions/generics/IndexedActions";
import {genericIndexedActions} from "../../../redux/actions/generics/GenericIndexedActions";

// services
import {afiService} from "../../../jwt/_services/hotel/afiService";

// utils
import {getStateByPath} from "../../../redux/selectors";
import {GenericButton} from "../../../components/buttons/customButtons";


const AfiList = props => {
    const {path} = props
    const componentState = useSelector(state => getStateByPath(state, path));
    const { app, pageSize, pageIndex, totalSize, listDomainObjects, filter} = componentState?.data || {};
    const fbDataBase = {id: app?.fbDataBase?.id}


    useEffect( () => {
        if(filter || !app?.id)
            return

        props.setFilter(path,{
            fbDataBase,
            onlyRegistered:true,
            item: { code: null }
        })
    }, [app]);

    useEffect(() => {
        if(!filter)
            return

        genericIndexedActions.search(path, afiService, pageIndex, pageSize, filter)
    }, [pageIndex, pageSize, filter]);


    const editItem = (data) => {
        props.setItem(path, data);
        props.setForm(path, true, false, false);

        ModalFormContainer(AfiForm, { path, data })
    }

    const createItem = () => {
        props.setItem(path, null);
        props.setForm(path)

        ModalFormContainer(AfiForm, { path })
    }


    const confirmDelete = (data) => ConfirmDelete({
        path,
        data,
        fbDataBaseId: app?.fbDataBase?.id,
        service: afiService,
        remove : genericIndexedActions.delete,
    } );

    const handleTableChange = (type, {page, sizePerPage}) => {
        let currentIndex = (page - 1) * sizePerPage
        props.setTableParams(path, sizePerPage, currentIndex, totalSize, currentIndex )
    };

    const activeFormatter = cell => <ActiveFormatter active={cell}/>

    const actionsFormatter = (cell, row) => <>
        <GenericButton style={'table'} toolTip={TT_EDIT} icon={'fa-pen'} permission={'edit'} onClick={() => editItem(row)}/>
        <TranslateButton item={row} service={afiService} path={path}/>
        <GenericButton style={'danger-secondary'} toolTip={TT_DELETE} icon={'fa-trash'} permission={'delete'} onClick={() => confirmDelete(row)}/>
    </>


    const columns = [{
            dataField: 'id',
            headerStyle: {width: '0px'},
            text: 'ID',
            hidden: true
        }, {
            dataField: 'uid',
            text: 'UID',
            headerStyle: {width: '200px'},
        }, {
            dataField: 'name',
            text: `${LB_NAME}`,
        }, {
            dataField: 'showOrder',
            text: 'Orden',
            headerAlign: 'center',
            align: 'center',
            headerStyle: {width: '80px'},
        }, {
            dataField: 'status',
            text: `${LB_ACTIVE}`,
            headerAlign: 'center',
            align: 'center',
            headerStyle: {width: '80px'},
            formatter: activeFormatter
        }, {
            dataField: 'actions',
            isDummyField: true,
            text: `${LB_ACTIONS}`,
            headerAlign: 'center',
            align: 'center',
            headerStyle: {width: '200px'},
            formatter: actionsFormatter
        }
    ];



    return <Card>
        <CardTitle className="bg-light border-bottom p-3 mb-0">
            <i className="far fa-list-alt mr-2"/>{LIST}
            <div className="float-right">
                <GenericButton
                    style={'table'}
                    label={'Agregar'}
                    toolTip={'Agregar'}
                    icon={'fa-plus'}
                    permission={'add'}
                    onClick={createItem}
                />
            </div>
        </CardTitle>

        <AfiFilters path={path}/>

        <CardBody>
            <BootstrapTable
                striped hover
                tableHeaderClass='mb-0'
                remote
                keyField="id"
                data={listDomainObjects || []}
                columns={ columns }
                noDataIndication={NO_DATA_FOUND}
                pagination={paginationFactory({pageIndex, pageSize, totalSize})}
                onTableChange={ handleTableChange }
            />
        </CardBody>
    </Card>
}

const mapStateToProps = state => ({})
const mapActionsToProps = ({
    setFilter,
    setTableParams,
    setForm,
    setItem,
})

export default connect(mapStateToProps, mapActionsToProps)(AfiList);